
import { Options, Vue } from "vue-class-component"; //基本需要
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import { getLocalProject, unique } from "@/utils"; //类型
import _FormItem from "element-plus/lib/el-form-item";

import {
  dispatchGetLoginSmokeReport,
  dispatchGetLoginSmokeReportList,
  dispatchSendLoginSmokeport,
  dispatchDeleteLoginSmokeport,
} from "@/store/performance/actions";
import { readProjectDetail } from "@/store/project/getters";
import { store } from "@/store";
import {
  readLoginSmokeReport,
  readLoginSmokeReportList,
} from "@/store/performance/getters";

import { ElMessage } from "element-plus";

// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class AutomatedSmokeTest extends Vue {
  //声明属性
  public localProject = Number(getLocalProject()); //得到本地的项目
  public report_id = 0; // 当前页面的报告id
  public name_search = "";
  public maskImg = "";
  // 测试结论
  public core_data: any[] = [];
  public link = "";
  public compare_link = "";
  public trend_data = {
    x_axis: ["1.0.30.13433"],
    scene_list: ["hall", "mp", "br"],
    mono: {
      hall: [145710],
      mp: [143410],
      br: [145410],
    },
    engine: {
      hall: [14510],
      mp: [145410],
      br: [145410],
    },
  };
  // 计算个数
  public test_num(localProject) {
    if (localProject != 17 && localProject != 4) {
      let total = this.smokeReport.test_info.test_case_list.length;
      let pass = this.smokeReport.test_info.test_case_list.filter(
        (v: any) => v.status === true
      ).length;
      let failures = this.smokeReport.test_info.test_case_list.filter(
        (v: any) => v.status === false
      ).length;
      this.smoke_List.forEach(function (v: any) {
        if (v.name === "登录遍历用例总数") {
          v.num = total;
        }
        if (v.name === "登录遍历用例通过数") {
          v.num = pass;
        } else if (v.name === "登录遍历用例失败数") {
          v.num = failures;
        }
      });
    } else {
      let total = this.smokeReport.test_info.total_case_list.length;

      let pass = this.smokeReport.test_info.total_case_list.filter(
        (v: any) => v.status === true
      ).length;
      let failures = this.smokeReport.test_info.total_case_list.filter(
        (v: any) => v.status === false
      ).length;
      this.smoke_List.forEach(function (v: any) {
        if (v.name === "地图总数") {
          v.num = total;
        }
        if (v.name === "通过地图数") {
          v.num = pass;
        } else if (v.name === "不通过地图数") {
          v.num = failures;
        }
      });
    }
  }

  public com_risk = "低风险";
  public resBase64: any[] = []; // 存储趋势图base64编码及相关信息
  public loading = false;
  public async mounted() {
    // 图表
    this.loading = true;
    await dispatchGetLoginSmokeReportList(store, {
      project: this.localProject,
    });
    if (this.$route.query.project) {
      this.localProject = Number(this.$route.query.project);
    }
    if (this.$route.query.report_id) {
      this.report_id = Number(this.$route.query.report_id);
      this.formMail.title = (readLoginSmokeReportList(store) as any[]).filter(
        (item: any) => item.id === this.report_id
      )[0]?.report_name;
    } else {
      this.report_id = readLoginSmokeReportList(store)[0]?.id;
      this.$router.push({
        query: { ...this.$route.query, report_id: this.report_id },
      });

      this.formMail.title = (readLoginSmokeReportList(store) as any[]).filter(
        (item: any) => item.id === this.report_id
      )[0]?.report_name;
    }

    await dispatchGetLoginSmokeReport(store, {
      project: this.localProject,
      report_id: this.report_id != undefined ? this.report_id : "",
    });
    // await dispatchGetTOPReport(store, {
    //   project: this.localProject,
    //   report_id: this.report_id,
    // });
    // await this.addressee; //解析邮件收件人
    this.resBase64 = [];
    // let c :any=document.getElementById('co')
    // let c1=document.getElementById('co1')
    // console.log((c as any).offsetHeight)
    // console.log((c1 as any).offsetHeight)

    // c.style.transform="rotate(-90deg)"
    await this.addressee;
    await this.smoke_report();
    await this.test_num(this.localProject);
    if (
      this.localProject === 34 ||
      this.localProject === 40 ||
      this.localProject === 47
    ) {
      this.formMail.Sender = "febechen@tencent.com";
    } else if (this.localProject === 37) {
      this.formMail.Sender = "ethanli@tencent.com";
    }
    this.loading = false;
  }
  // 获取当前项目基本信息
  public get project_info() {
    return readProjectDetail(store);
  }
  // 切换报告
  public async report_change() {
    this.loading = true;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });

    this.formMail.title = (readLoginSmokeReportList(store) as any[]).filter(
      (item: any) => item.id === this.report_id
    )[0]?.report_name;

    await dispatchGetLoginSmokeReport(store, {
      project: this.localProject,
      report_id: Number(this.report_id),
    });
    this.resBase64 = [];

    await this.smoke_report();
    await this.test_num(this.localProject);
    this.loading = false;
  }

  //  判定是否通过
  public test_result(result: boolean) {
    if (result) {
      return "成功";
    } else {
      return "失败";
    }
  }
  // 解析邮件人
  public get addressee() {
    let addressee = this.smokeReport.receiver.join(";");
    this.formMail.addressee = addressee;

    return addressee;
  }

  // 删除报告
  public async handleDelete() {
    this.loading = true;
    this.resBase64 = [];
    await dispatchDeleteLoginSmokeport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    await dispatchGetLoginSmokeReportList(store, {
      project: this.localProject,
    });

    this.report_id = readLoginSmokeReportList(store)[0]?.id;

    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });

    await dispatchGetLoginSmokeReport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    await this.smoke_report();

    this.loading = false;
  }
  // public get codm_reports() {
  //   return readCODMReportList(store);
  // }
  // public get_color(value: number | string, type: number) {
  //   if (typeof value === "number") {
  //     if (value < 0) {
  //       return "green";
  //     }
  //   } else if (typeof value === "string") {
  //     if (value.indexOf("-") !== -1) {
  //       return "green";
  //     } else if (value.indexOf("%") !== -1) {
  //       const value_number = Number(value.split("%")[0]);
  //       if (value_number >= 8) {
  //         return "pink";
  //       } else if (value_number > 5) {
  //         return "pink2";
  //       } else {
  //         if (type === 1) {
  //           return "green";
  //         }
  //       }
  //     }
  //   }
  // }
  // public set_report() {
  //   const report = readCODMReport(store);
  //   this.test_info = report.test_info;
  //   this.memory_data = report.memory_data;
  //   this.memory_analysis = report.memory_analysis;
  //   this.trend_data = report.trend_data;
  //   this.core_data = report.core_data;
  //   this.link = report.link;
  //   this.compare_link = report.compare_link;
  // }
  // 判断是否是管理员
  // public get get_is_super() {
  //   let judge = true;
  //   let MyProject = readMyProjects(store).filter(
  //     (item: any) => item.project.id == this.localProject
  //   )[0]?.is_project_admin;
  //   if (readUserProfile(store)?.is_super) {
  //     judge = false;
  //   } else if (MyProject) {
  //     judge = false;
  //   } else {
  //     judge = true;
  //   }
  //   return judge;
  // }
  // 获取当前项目基本信息
  // public get project_info() {
  //   return readProjectDetail(store);
  // }
  // public get_trend_color(trend: string, control: number) {
  //   let new_trend = Number(trend.split("%")[0]); // 绝对值
  //   let new_trend1 = trend.split("%")[1]; // ↑ or ↓
  //   if (new_trend < 5 || new_trend1 === "↓") {
  //     if (control === 1) {
  //       return "color: green;";
  //     } else {
  //       return "";
  //     }
  //   } else if (new_trend < 8) {
  //     return "color: orange;";
  //   } else {
  //     return "color: red;";
  //   }
  // }
  // public get_risk_color(com_risk: string) {
  //   if (com_risk === "高风险") {
  //     return "color: red;font-weight: bold;";
  //   } else if (com_risk === "中风险") {
  //     return "color: orange;font-weight: bold;";
  //   } else {
  //     return "color: green;font-weight: bold;";
  //   }
  // }
  // 设置当前报告风险
  // public get_risk() {
  //   let top: any[] = [];
  //   let mid: any[] = [];
  //   this.core_data.forEach((item) => {
  //     if (item.risk === "高风险") {
  //       top.push(1);
  //     } else if (item.risk === "中风险") {
  //       mid.push(1);
  //     }
  //   });
  //   if (top.length >= 1) {
  //     this.com_risk = "高风险";
  //   } else if (mid.length >= 1) {
  //     this.com_risk = "中风险";
  //   }
  // }

  //图表

  // 头部
  public edit = false;
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public showMask = false;
  public imgBtn(sc: any) {
    this.showMask = true;
    this.maskImg = sc;
  }
  // 冒烟table头部列表
  public smokeList = [
    "序号",
    "用例名称",
    "测试结果",
    "测试说明",
    "测试时间",
    "场景截图",
  ];
  public maskBtn(ev: any) {
    if (!(this.$refs.mask as any).contains(ev.target)) {
      this.showMask = false;
    }
  }
  public smokeListData = [
    {
      title: "download",
      name: "下载",
      test: "成功",
      testExplain: "下载包成功",
      testTime: "2022-05-25 10:31:10",
      sceneScreenshot: "",
    },
  ];
  // 点击发送
  public sendOut() {
    this.edit = !this.edit;
  }
  // 获取列表信息
  public get smoke_lists() {
    let name_list: any[] = [];
    name_list = readLoginSmokeReportList(store);
    // console.log(name_list)
    return name_list;
  }
  public smokeReport = {
    test_info: {
      test_case_list: [],
      total_case_list: [],
    },
    project_icon: "",
    report_name: "",
    log_info: [],
    receiver: [],
    model_name: "",
    pipeline_url: "",
    vedio: [],
  };
  // 获取页面数据
  public smoke_report() {
    this.smokeReport.test_info = readLoginSmokeReport(store).data.test_info;
    this.smokeReport.project_icon = readLoginSmokeReport(
      store
    ).data.project_icon;
    this.smokeReport.report_name = readLoginSmokeReport(store).data.report_name;
    this.smokeReport.log_info = readLoginSmokeReport(store).data.log_info;
    this.smokeReport.receiver = readLoginSmokeReport(store).data.receiver;
    this.smokeReport.model_name = readLoginSmokeReport(store).data.model_name;
    this.smokeReport.pipeline_url = readLoginSmokeReport(
      store
    ).data.pipeline_url;
    this.smokeReport.vedio = readLoginSmokeReport(store).data.vedio;
  }
  //   冒烟列表
  public get smoke_List() {
    let list = [];
    if (this.localProject != 17 && this.localProject != 4) {
      list = [
        { num: "20", name: "登录遍历用例总数" },
        { num: "10", name: "登录遍历用例通过数" },
        { num: "10", name: "登录遍历用例失败数" },
      ];
    } else {
      list = [
        { num: "20", name: "地图总数" },
        { num: "10", name: "通过地图数" },
        { num: "10", name: "不通过地图数" },
      ];
    }

    return list;
  }
  public async save_report() {
    let upload_data: any;
    if (
      this.localProject === 34 ||
      this.localProject === 40 ||
      this.localProject === 47
    ) {
      this.formMail.Sender == "febechen@tencent.com";
    } else if (this.localProject === 37) {
      this.formMail.Sender == "ethanli@tencent.com";
    }
    upload_data = {
      // project: Number(this.$route.query.project),
      project: Number(this.localProject),
      report_id: Number(this.report_id),
      title: this.formMail.title,
      recv: this.formMail.addressee,
      cc: this.formMail.CC_List,
      send: this.formMail.Sender,
    };
    dispatchSendLoginSmokeport(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
    this.edit = false;
  }
  //   public get_project_users() {
  //     const project_users = readProjectUsers(store);
  //     let user_list: any[] = [];
  //     project_users.forEach((item) => {
  //       if (item.is_project_admin) {
  //         user_list.push(item.user);
  //       }
  //     });
  //     return unique(user_list).join(";");
  //   }
}
